module.exports = __webpack_public_path__ + "static/media/beta-icon.ea7325af.png";